import { CashAccountLiteModel, CashAccountModel } from 'api-hooks/cash-account';
import { EmployeeLiteModel } from 'api-hooks/employee';
import { TransactionCategoryLiteModel } from 'api-hooks/transaction-category';
import { Expose, Type } from 'class-transformer';
import { TransactionalStatusEnum } from 'common/constants/enum';
import {
  CommonModel,
  CommonParamInput,
} from 'common/repositories/common.model';

export class TransactionModel {
  id: string;
}

export enum CashTransactionTypeEnum {
  debit = 'debit',
  credit = 'credit',
}

class CommonCashTransactionModel extends CommonModel {
  status: TransactionalStatusEnum;
  type: string;
  description: string;
  number: string;

  @Expose({ name: 'transaction_at' })
  @Type(() => Date)
  transactionAt: Date;

  @Type(() => Number)
  amount: number;

  @Expose({ name: 'cash_transaction_items' })
  @Type(() => TransactionModel)
  cashTransactionItems: TransactionModel[];

  @Expose({ name: 'transaction_category' })
  @Type(() => TransactionCategoryLiteModel)
  transactionCategory: TransactionCategoryLiteModel | null;

  @Expose({ name: 'is_resolved' })
  isResolved: boolean;
}

export class CashTransactionLiteModel extends CommonCashTransactionModel {
  @Expose({ name: 'cash_account' })
  @Type(() => CashAccountLiteModel)
  cashAccount: CashAccountLiteModel;

  @Expose({ name: 'created_by' })
  @Type(() => EmployeeLiteModel)
  createdBy: EmployeeLiteModel;
}

export class CashTransactionModel extends CommonCashTransactionModel {
  @Expose({ name: 'ref_id' })
  refId: string;

  @Expose({ name: 'cash_account' })
  @Type(() => CashAccountModel)
  cashAccount: CashAccountModel;
}

export class getCashTransactionsInput {
  params: CommonParamInput;
}

export class getCashTransactionInput {
  id: string;
}

export class CashTransactionMutationInput {
  transactionAt: Date;
  cashAccountId: string;
  needApproval: boolean;
  type: string;
  amount: number;
  description: string;
  transactionCategoryId: string | null;
}

export class CashTransactionUpdateInput {
  cashTransactionId: string;
  body: CashTransactionMutationInput;
}

export class CashTransactionDeleteInput {
  cashTransactionId: string;
}
